import React from 'react';

import ServicetjekHero from '../Hero';
import MaalrettetMeddelelser from '../MaalrettetMeddelelser';

import Doc from '@Components/PdfContainer/DocService';
import PdfContainer from '@Components/PdfContainer';

import { IMaalrettetMeddelelserSamlet } from './MaalrettetMeddelelserSamlet.definition';

const MaalrettetMeddelelserSamlet = (props: IMaalrettetMeddelelserSamlet) => {
	const { hero, meddelelser, footer, genererPdf, pdfInfoText, pdfNavn } = props;

	const createPdf = () => Doc.createPdf();

	const renderPdfElement = () => {
		return (
			<PdfContainer createPdf={ createPdf } buttonText="" successText="" autoSave apiUrl="/api/WebDokumentationApi/GemDokumentation" documentName={ `${pdfNavn}.pdf` }>
				<div dangerouslySetInnerHTML={ { __html: pdfInfoText } } />
				{ renderContainer(true) }
			</PdfContainer>
		);
	};

	const renderContainer = (isPDF: boolean) => (
		<>
			{ hero && <ServicetjekHero { ...hero } isPDF={ isPDF } /> }
			{ meddelelser && <MaalrettetMeddelelser meddelelser={ meddelelser } isPDF={ isPDF } /> }
			{ footer && <ServicetjekHero { ...footer } isPDF={ isPDF } /> }
		</>
	);

	return (
		<>
			{ renderContainer(false) }
			{ genererPdf && renderPdfElement() }
		</>
	);
};

export default MaalrettetMeddelelserSamlet;
